import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';


export default function convertBooleanToYesNo(value) {
    // Check if the value is a boolean
    if (typeof value !== 'boolean') {
        throw new Error('Input must be a boolean value');
    }

    // Convert boolean to "Yes" or "No"
    return value ? 'Yes' : 'No';
}

export function convertBooleanToDoneNotDoneIcons(value) {
    // Check if the value is a boolean
    if (typeof value !== 'boolean') {
        throw new Error('Input must be a boolean value');
    }

    // Convert boolean to "Yes" or "No"
    return value ? <DoneIcon sx={{ color: 'green' }} /> : <CloseIcon sx={{ color: 'red' }} />;
}